const loadMoreNews = {
	el: {
		container: document.querySelector('.js-news'),
		loadmoreButton: document.querySelector('.js-loadmore-button')
	},

	vars: {
		numberOfItemsLoaded: 3,
		numberOfItemsToShow: 3
	},

	fxLoadCards(numberItemsShowing = 3) {
		const cardItems = [...this.el.container.children]

		for (const card of cardItems)
			card.classList.add('d-none')

		for (const card of cardItems.slice(0, numberItemsShowing))
			card.classList.remove('d-none')

		if (numberItemsShowing >= cardItems.length || cardItems.length <= this.vars.numberOfItemsLoaded)
			this.el.loadmoreButton.style.display = 'none'

	},

	events() {
		this.el.loadmoreButton.addEventListener('click', () => {
			this.vars.numberOfItemsToShow = this.vars.numberOfItemsToShow + this.vars.numberOfItemsLoaded
			this.fxLoadCards(this.vars.numberOfItemsToShow)
		})
	},

	init() {
		if (this.el.container) {
			this.events()
			this.fxLoadCards()
		}
	}
}
loadMoreNews.init()